import React, { useState, useEffect } from "react";
import { IonPage, IonContent, IonButton } from "@ionic/react";

const getRandomTime = () => {
    const hours = Math.floor(Math.random() * 12) + 1; // 1 to 12
    const minutes = Math.floor(Math.random() * 12) * 5; // 0, 5, 10, ..., 55
    return { hours, minutes };
};

// Format time as "hh:mm"
const formatTime = ({ hours, minutes }: { hours: number; minutes: number }) => {
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
};

// Generate 3 incorrect answers that are different from the correct one
const generateOptions = (correctTime: string) => {
    const options = new Set<string>();
    options.add(correctTime);

    while (options.size < 3) {
        const randomTime = formatTime(getRandomTime());
        if (!options.has(randomTime)) {
            options.add(randomTime);
        }
    }
    return Array.from(options).sort(() => Math.random() - 0.5); // Shuffle
};

const ChooseTime: React.FC = () => {
    const [time, setTime] = useState(getRandomTime());
    const [options, setOptions] = useState<string[]>([]);
    const [selected, setSelected] = useState<string | null>(null);
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [feedback, setFeedback] = useState("");
    const [showImage, setShowImage] = useState(false);
    document.title = "Mamas Guidance - LKG - Mathematics - Clock - Choose Correct Time";

    useEffect(() => {
        const correctTime = formatTime(time);
        setOptions(generateOptions(correctTime));
    }, [time]);

    const handleOptionClick = (option: string) => {
        setSelected(option);
        if (option === formatTime(time)) {
            setShowImage(true);
            setTimeout(() => {
                setTime(getRandomTime());
                setShowImage(false);
                setFeedback("")
            }, 5000)
        } else {
            setShowImage(false);
            setFeedback("❌ Oops! Try again.");
        }
    };

    return (
        <>
            {
                showImage === false ?
                    <>
                        <div className="contentPart additionWord pickColor matchImage" style={{ textAlign: "center", padding: "20px" }}>
                            {/* <h2>What time is shown on the clock?</h2> */}

                            {/* Clock Display */}
                            <div
                                style={{
                                    width: "200px",
                                    height: "200px",
                                    borderRadius: "50%",
                                    border: "5px solid black",
                                    margin: "20px auto",
                                    position: "relative",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: "white",
                                }}
                            >
                                {/* Clock Numbers */}
                                {[...Array(12)].map((_, i) => {
                                    const angle = (i + 1) * 30;
                                    const x = 85 + 80 * Math.sin((angle * Math.PI) / 180);
                                    const y = 85 - 80 * Math.cos((angle * Math.PI) / 180);

                                    return (
                                        <div
                                            key={i}
                                            style={{
                                                position: "absolute",
                                                left: `${x}px`,
                                                top: `${y}px`,
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {i + 1}
                                        </div>
                                    );
                                })}

                                {/* Hour Hand */}
                                <div
                                    style={{
                                        width: "5px",
                                        height: "50px",
                                        backgroundColor: "black",
                                        position: "absolute",
                                        left: "50%",
                                        bottom: "50%",
                                        transformOrigin: "bottom",
                                        transform: `rotate(${(time.hours % 12) * 30 + (time.minutes / 60) * 30}deg)`,
                                    }}
                                />

                                {/* Minute Hand */}
                                <div
                                    style={{
                                        width: "3px",
                                        height: "65px",
                                        backgroundColor: "black",
                                        position: "absolute",
                                        left: "50%",
                                        bottom: "50%",
                                        transformOrigin: "bottom",
                                        transform: `rotate(${time.minutes * 6}deg)`,
                                    }}
                                />
                            </div>

                            {/* Answer Options */}
                            <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
                                {options.map((option, index) => (
                                    <div className="purpleButton"
                                        key={index}
                                        onClick={() => handleOptionClick(option)}
                                        style={{ margin: "5px", padding: "10px", minWidth: "60px" }}
                                    >
                                        {option}
                                    </div>
                                ))}
                            </div>

                            {/* Feedback */}
                            {feedback && <p>{feedback}</p>}
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default ChooseTime;
